"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHeaders = void 0;
var _auth = require("@ori/auth");
var _constants = require("../constants");
var _prepareToken = require("./prepareToken");
/**
 * Utility function for generating core headers for HTTP requests. Returns object with headers.
 * @example
 *
 * const headers = getHeaders({
 *       sourceAppName: 'app',
 *       language: 'cs',
 *       customerId: 1,
 *       tenant: 'cz',
 *       token: 'some-token',
 *     }),
 *
 * useGraphqlQuery({query, url, headers: headers})
 */ var getHeaders = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, sourceAppName = _ref.sourceAppName, language = _ref.language, customerId = _ref.customerId, tenant = _ref.tenant, token = _ref.token;
    var headers = _define_property({}, _constants.CONTENT_TYPE, _constants.JSON_CONTENT);
    var formattedToken = (0, _prepareToken.formatToken)(token);
    if (formattedToken) {
        headers[_constants.AUTHORIZATION] = formattedToken;
    }
    if (sourceAppName) {
        headers[_constants.CLIENT_APPLICATION] = sourceAppName;
    }
    if (language) {
        headers[_constants.ACCEPT_LANGUAGE] = language;
    }
    if ((0, _auth.isAuthenticatedCustomer)(customerId)) {
        headers[_constants.CUSTOMER_CONTEXT] = customerId.toString();
    }
    if (tenant) {
        headers[_constants.TENANT_CONTEXT] = tenant;
    }
    return headers;
};
exports.getHeaders = getHeaders; //# sourceMappingURL=getHeaders.js.map
